import * as React from "react";
import { Helmet } from "react-helmet";
import * as AuthStore from "../store/Auth";
import { connect } from "react-redux";
import { ApplicationState } from '../store';
import { withRouter } from "react-router";
import { fetchData, postQuery } from '../utils';
import { Redirect } from "react-router-dom";
import { EditOutlined } from '@ant-design/icons/lib';
import { Table, Input, Button, Select, Form, Row, message, Col, Modal } from 'antd';
const { Option } = Select;
const { Item } = Form;


type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

interface User
{
    id: string;
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    password: string;
    confirmPassword: string;
    facilityId: number;
    stateCode: string;
    phoneNumber: string,
    role: string;
    [key: string]: User[keyof User];
}

class Users extends React.Component<AuthProps>
{
    public state =
        {
            buttonText: 'Add',
            data: [],
            roles: [],
            site: { id: 0, name: '', stateName: '', stateCode: '', stateId: '' },
            state: { id: 0, name: '', code: '', sites: [] },
            states: [],
            sites: [],
            stateList: [],
            siteList: [],
            pagination:
            {
                current: 1,
                total: 0,
                pageSize: 10,
                sorter:
                {
                    field: "name",
                    order: "asc"
                }
            },
            userId: 0,
            loading: false,
            confirmLoading: false,
            title: 'New User',       
            user: { id: '', firstName: '', lastName: '', userName: '', email: '', password: '', confirmPassword: '', role: '', facilityId: 0, stateCode: '', phoneNumber: '' },
            searchText: "",
            visible: false,
            selected: false
        };          
    ////@ts-ignore
    async componentDidMount()
    {
        let el = this;

        let user: User = { id: '', firstName: '', lastName: '', userName: '', email: '', password: '', confirmPassword: '', role: '', facilityId: 0, stateCode: '', phoneNumber: '' };
        el.setState({ user: user });

        let roles = await fetchData(`/api/Account/getRoles`);
        el.setState({ roles: roles });

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let statesLoaded = true;
        this.setState({ states, statesLoaded });

        var pushForm = document.getElementById("users");
        if (pushForm)
        {
            pushForm.addEventListener("keyup", function (event)
            {
                var elm = document.getElementById("submit-btn");
                if (event.keyCode === 13 && elm)
                {
                    event.preventDefault();
                    elm.click();
                }
            });
        }

        const { pagination } = this.state;
        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });      
    }
    
    ////@ts-ignore
    async selectRole(value: any)
    {
        const { user } = this.state;
        let role = "";
        if (value)
        {
            role = value.key;
        }
        user.role = role;
        this.setState({ user });
    }

    edit(data: any, row: any)
    {
        let el = this;
        if (data.stateCode && data.stateCode.length > 0)
        {
            let states = this.state.states.filter(function (s: any) { return s.code === data.stateCode });

            if (states.length > 0)
            {
                let state: any = states[0];
                let sites = el.state.sites.filter(function (o: any) { return o.stateCode === state.code });
                state.sites = sites;
                el.setState({ state });
            }
            else
            {
                el.setState({ state: { id: 0, name: '', code: '', sites: [] } });
            }
        }       
        if (!data.facilityId || data.facilityId < 1)
        {
            data.facilityId = '';
        }   
        el.setState({ visible: true, title: 'Update User', buttonText: 'Update', user: data });
    }

    add()
    {
        this.setState({ visible: true, title: 'Add User', buttonText: 'Add', user: { id: '', firstName: '', lastName: '', userName: '', email: '', password: '', confirmPassword: '', role: '', facilityId: '', stateCode: '', phoneNumber: '' }, state: { id: 0, name: '', code: '', sites: [] } });
    }
    
    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }  
    ////@ts-ignore
    async getItems(params: any) 
    {        
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        let el = this;
        
        var query = `/api/Account/getUsers?itemsPerPage=${results}&pageNumber=${page}&searchText=${searchText}`;
       
        el.setState({loading: true});
        
        let res = await fetchData(query);

        el.setState({loading: false});

        if (res.users.length > 0)
        {
            res.users.map(function (r: any)
            {
                r.password = '';
                r.confirmPassword = '';

                let rr: any = el.state.roles.filter(function (f: any) { return f.id === r.role});
                if (rr.length > 0)
                {
                    r.roleName = rr[0].name;
                }
                else
                {
                    r.roleName = "";
                }

                if (r.facilityId && r.facilityId > 0)
                {
                    var facilities = el.state.sites.filter(function (s: any) { return s.id === r.facilityId });
                    if (facilities.length > 0)
                    {
                        r.facilityName = facilities[0].name;
                    }
                }                
            });

            const { pagination } = el.state;
            pagination.total = res.totalItems;           
            el.setState({
                data: res.users,
                pagination
            });
        }

        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.firstName.toString().match(reg) || record.lastName.toString().match(reg) || record.email.toString().match(reg);

                    if (!match)
                    {
                        return null;
                    }
                    return record;
                    //{
                    //    ... record
                    //    ,
                    //    firstName: record.firstName
                    //    //    (<span> {record.firstName.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                    //    //))}
                    //    //</span>
                    //    //)
                    //};
                }).filter(record => !!record)
            });
        }
    }

    handleChange(value: any) {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            //sortField: pagination.sorter.field,
            //sortOrder: pagination.sorter.order
        });
    }

    onInputChange(e: any)
    {
        let searchTerm = e.target.value.trim();
        this.setState({searchText: searchTerm});
        const { pagination } = this.state;
        this.getItems({
            results: pagination.pageSize,
            searchText: searchTerm,
            page: pagination.current
        });
    }
      
    onSearch()
    {
        const { pagination } = this.state;
        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    ////@ts-ignore
    async getUser(row: any)
    {
        let el = this;

        var query = `/api/Account/getUser?id=${row.id}`;

        el.setState({ loading: true });

        let user = await fetchData(query);
        el.setState({ loading: false });
      
        if (user.id > 0)
        {          
            el.setState({
                user: user,
                visible: true
            });
        }
        else
        {
            message.error('User information could not be retrieved');
        }
    }
    ////@ts-ignore
    async process()
    {
        if (!this.state.user.firstName)
        {
            message.error("Please provide User's First Name");
            return;
        }
        if (!this.state.user.lastName)
        {
            message.error("Please provide User's Last Name");
            return;
        }
        if (!this.state.user.lastName)
        {
            message.error("Please provide User's Last Name");
            return;
        }
        if (!this.state.user.role || this.state.user.role.length < 1)
        {
            message.error("Please select a role for user");
            return;
        }
        if (!this.state.user.email)
        {
            message.error("Please provide User's Email");
            return;
        }
        if (!this.state.user.id)
        {
            if (!this.state.user.password)
            {
                message.error("Please provide User's Password");
                return;
            }
            if (!this.state.user.confirmPassword)
            {
                message.error("Please confirm User's confirmPassword");
                return;
            }
        }
        let url = '';
        let payload = {};
        if (!this.state.user.id || this.state.user.id.length < 1)
        {
            url = '/api/Account/register';
            payload =  
            {
                firstName: this.state.user.firstName, 
                lastName: this.state.user.lastName, 
                userName: this.state.user.email,
                email: this.state.user.email,
                password: this.state.user.password,
                confirmPassword: this.state.user.confirmPassword,
                role: this.state.user.role,
                phoneNumber: this.state.user.phoneNumber,
                facilityId: !this.state.user.facilityId? 0: this.state.user.facilityId,
                stateCode: this.state.user.stateCode
            }
        }
        else 
        {
            url = '/api/Account/updateUser';
            payload =  
            { 
                id: this.state.user.id, 
                firstName: this.state.user.firstName, 
                lastName: this.state.user.lastName, 
                userName: this.state.user.userName,
                email: this.state.user.email,
                password: this.state.user.password,
                confirmPassword: this.state.user.confirmPassword,
                role: this.state.user.role,
                phoneNumber: this.state.user.phoneNumber,
                facilityId: !this.state.user.facilityId ? 0 : this.state.user.facilityId,
                stateCode: this.state.user.stateCode
            };
        }      

        const { pagination } = this.state;
        let params = {
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        };

        this.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(payload));
        this.setState({ confirmLoading: false });
        if (res.code > 0) {
            this.getItems(params);
            this.setState({ visible: false });
            message.success(res.message);
        }
        else
        {
           message.error(res.message);
        }
    }
    
    exit()
    {
        this.setState({
            visible: false
        });
    }

    handleSelectChange(feature: any, value: any, target: any) 
    {
        let user: any = this.state.user;
        user[feature] = value[target];
        this.setState({user});
    }

    textChange(feature: string, e: any)
    {
        let user: User = this.state.user;  
        var val = e.target.value;
        user[feature] = val;
        this.setState({ user });
    }

    selectSite(value: any)
    {
        const { user } = this.state;
        if (value)
        {
            user.facilityId = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.id === value.key });
            if (sites.length > 0) user.facilityId = sites[0].id;
            this.setState({ user });
        }
    }

    selectState(value: any)
    {
        if (!value)
        {
            return;
        }
        const { user } = this.state;
        if (value)
        {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateCode === val });
            if (states.length > 0)
            {
                let state: any = states[0];
                user.stateCode = state.stateCode;
                this.setState({ state, user });
            }
            else
            {
                user.stateCode = "";
                this.setState({ user, state: { id: 0, name: '', code: '', sites: [] } });
            }
        }
    }

    render() 
    {
        const { searchText, selected, user, confirmLoading, buttonText, visible, title, roles, state, states } = this.state;
        let el = this;
        if (!el.props.appUser.isAuthenticated || el.props.appUser.role !== "1")
        {
            return <Redirect to="/welcome" />;
        }

        const columns =
            [
                {
                    title: 'First Name',
                    dataIndex: 'firstName',
                    key: 'firstName'
                },
                {
                    title: 'Last Name',
                    dataIndex: 'lastName',
                    key: 'lastName'
                },
                {
                    title: 'Email',
                    dataIndex: 'email',
                    key: 'email'
                },
                {
                    title: 'Phone Number',
                    dataIndex: 'phoneNumber',
                    key: 'phoneNumber'
                },
                {
                    title: 'Role',
                    dataIndex: 'roleName',
                    key: 'roleName'
                },
                {
                    title: 'Status',
                    dataIndex: 'lockoutEnabled',
                    key: 'lockoutEnabled'
                },
                {
                    title: 'Facility',
                    dataIndex: 'facilityName',
                    key: 'facilityName'
                },
                {
                    title: 'State',
                    dataIndex: 'stateCode',
                    key: 'stateCode'
                },
                {
                    title: 'Last Seen',
                    dataIndex: 'lastSeen',
                    key: 'lastSeen'
                },
                {
                    title: 'Update',
                    dataIndex: '', key: 'x',
                    render: (value: any, row: any, index: any) => <a key={value.id} title="update" onClick={() => this.edit(value, row)} style={{ cursor: 'pointer' }}><EditOutlined /></a>
                }
        ];         
        
        
        return (
            <div style={{marginTop: '15px', padding: '20px'}}>
                <Helmet>
                    <title>CDR - Users</title>
                </Helmet>
                <div style={{display: selected? 'none':'block'}}>
                    <div className="custom-filter-dropdown">
                        <Row style={{ marginTop: '2px' }}>
                            <Col span={24}>
                                <h4 style={{fontWeight: 'bold', fontSize: '18px'}}>Users</h4>
                            </Col>
                        </Row>
                        <Row gutter={2} style={{ marginTop: '10px' }}>
                            <Col xs={24} sm={24} md={6} lg={6}>
                                <Select defaultValue="10" className="top-10-margin" id="pageSize" onChange={this.handleChange} style={{ width: '100%' }}>
                                    <Option value="10">10</Option>
                                    <Option value="25">25</Option>
                                    <Option value="50">50</Option>
                                    <Option value="100">100</Option>
                                </Select>
                            </Col>
                            <Col xs={24} sm={24} md={8} lg={8} style={{ paddingLeft: '10px' }}>
                                <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search..." value={searchText} onChange={(e) => this.onInputChange(e)} onPressEnter={(e) => this.onSearch()} />
                            </Col>
                            <Col xs={24} sm={24} md={4} lg={4} style={{ paddingLeft: '10px' }}>                           
                                <Button disabled={confirmLoading} className="login-button top-10-margin" id="push-btn" loading={confirmLoading} key="submit" type="primary" size="large" onClick={() => this.add()} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'left', width: '95%' }}>
                                    <span id="buttonText">Add User</span>
                                </Button>
                            </Col>
                        </Row>
                        <br />
                        <Row gutter={2}>
                            <Col span={24} style={{ overflow: "scroll" }}>
                                <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />    
                            </Col>
                        </Row>
                    </div>
                    <div className="md-wrapper">
                        <Modal className="modal-width-500"
                            visible={visible}
                            title={title}
                            maskClosable={false}
                            onCancel={() => this.exit()}
                            footer={[
                                <Button id="submit-btn" className="login-button" style={{width: '60%'}} loading={confirmLoading} key="submit" type="primary" size="large" onClick={() => this.process()}>
                                    <span id="buttonText">{buttonText}</span>
                                </Button>
                            ]}>

                            <Form id="users">
                                <div className='ant-row'>
                                    <div className='ant-col-24 padding-md'>
                                        <Item>
                                            <Row>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingRight: '5px'}}>
                                                    <input onChange={(e) => this.textChange('firstName', e)} name="firstName" type="text" className="ant-input ant-input-lg input-no-border" placeholder="First Name *" value={user.firstName} />
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingLeft: '5px' }}>
                                                    <input onChange={(e) => this.textChange('lastName', e)} name="lastName" type="text" className="ant-input ant-input-lg input-no-border" placeholder="Last Name *" value={user.lastName} />
                                                </Col>
                                            </Row>                                           
                                        </Item>                                   
                                        <Item>
                                            <Row>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingRight: '5px' }}>
                                                    <input onChange={(e) => this.textChange('email', e)} name="email" type="email" className="ant-input ant-input-lg input-no-border" placeholder="Email *" value={user.email} />
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingLeft: '5px' }}>
                                                    <input onChange={(e) => this.textChange('phoneNumber', e)} name="phoneNumber" type="text" className="ant-input ant-input-lg input-no-border" placeholder="Phone Number" value={user.phoneNumber} />
                                                </Col>
                                            </Row>                                           
                                        </Item>
                                        <Item>
                                            <Row>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingLeft: '5px' }}>
                                                    <input onChange={(e) => this.textChange('password', e)} name="password" type="password" className="ant-input ant-input-lg input-no-border" placeholder="Password *" value={user.password} />
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingRight: '5px' }}>
                                                    <input onChange={(e) => this.textChange('confirmPassword', e)} name="confirmPassword" type="password" className="ant-input ant-input-lg input-no-border" placeholder="Confirm Password *" value={user.confirmPassword} />
                                                </Col>
                                            </Row>                                            
                                        </Item>
                                        <Item>
                                            <Row>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingLeft: '5px' }}>
                                                    <Select className="circl-radius"
                                                        labelInValue
                                                        showSearch
                                                        optionFilterProp="children"
                                                        //@ts-ignore
                                                        value={{ key: user.stateCode }}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select State"
                                                        onChange={(value) => this.selectState(value)}
                                                    >
                                                        <Option key="" value="">-- Select State --</Option>
                                                        {states && states.map((s: any) => <Option key={s.stateCode} value={s.stateCode}>{s.stateName}</Option>)}
                                                    </Select>
                                                </Col>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingRight: '5px' }}>
                                                    <Select className="circl-radius"
                                                        labelInValue
                                                        showSearch
                                                        optionFilterProp="children"
                                                        style={{ width: '100%' }}
                                                        //@ts-ignore
                                                        value={{ key: user.facilityId }}
                                                        placeholder="Select Site"
                                                        onChange={(value) => this.selectSite(value)}
                                                    >
                                                        <Option key="" value="">-- Select Site --</Option>
                                                        {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                                    </Select>
                                                </Col>
                                            </Row>    
                                        </Item>
                                        <Item>
                                            <Row>
                                                <Col xs={24} sm={24} md={12} lg={12} style={{ paddingLeft: '5px' }}>
                                                    <Select
                                                        labelInValue
                                                        style={{ width: '100%' }}
                                                        //@ts-ignore
                                                        value={{ key: user.role }}
                                                        placeholder="Select Role"
                                                        onChange={(value) => this.selectRole(value)}
                                                    >
                                                        <Option value="">-- Select Role --</Option>
                                                        {roles && roles.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                                                    </Select>
                                                </Col>
                                            </Row>
                                        </Item>
                                    </div>
                                </div>
                            </Form>
                        </Modal>
                    </div>
            </div>              
        </div>
    )}
}

var component = connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Users as any);

// @ts-ignore
export default (withRouter(component));

